import React from 'react';


import component, {classnames, makePath} from '../component';
import TopBanner from '../TopBanner';
import {HBox, VBox} from '../Box';
import {ArrowRight} from '../icons';
import Link from '../Link';


const SitemapLink = component('SitemapLink', function({href, title, description}) {
  return (
    <div className="Sitemap-Link--Wrap">
      <Link href={href} className="Sitemap-Link" >
        {title}
        <ArrowRight className="Sitemap-LinkArrow" />
      </Link>
      {
        description
        &&
        <div className="Sitemap-LinkDescription">
          {description}
        </div>
      }
    </div>
  )
})

export default component('Sitemap', function({data}) {
  function renderFlatPages(item) {
    return (
      <SitemapLink href={item.get('url')} title={item.get('title')} />
    )
  }

  const flatPages = data.cursor('flatPages').deref() && data.cursor('flatPages').map(renderFlatPages);

  return (
    <div>
      <TopBanner size='tiny' />
      <HBox width={4}>
        <div className="Sitemap">
            <h1 className="Sitemap-Title">Карта сайта</h1>
            <div className="Sitemap-Caption"></div>
          <div className="Sitemap-Links">
            <div className="Sitemap-Main">
              <SitemapLink
                href={makePath('home', {})}
                title='Главная страница'
              />
            </div>
            <div className="Sitemap-Secondary">
              <SitemapLink
                href={makePath('newsHome', {})}
                title='Новости'
                description='Будь в курсе событий.'
              />
              <SitemapLink
                href={makePath('tournaments', {})}
                title='Турниры'
                description='Если хочешь сражаться и побеждать, этот раздел специально для тебя.'
              />
              <SitemapLink
                href={makePath('teams', {})}
                title='Команды'
                description='Если желаешь найти свою единственную команду или изучить соперников.'
              />
              <SitemapLink
                href={makePath('players', {})}
                title='Игроки'
                description='Ищи тиммейтов, следи за достижениями других игроков.'
                />
              <SitemapLink
                href={makePath('faq', {})}
                title='FAQ'
                description='Основные вопросы по взаимодействию с турнирной платформой.'
                />
              {flatPages}
              <div className="Sitemap-Link--Wrap">
                <div className="Sitemap-Link Sitemap-Link--Current">
                  Карта сайта
                </div>
                <div className="Sitemap-LinkDescription">
                </div>
              </div>
            </div>
          </div>
        </div>
      </HBox>
    </div>
  );
});



// WEBPACK FOOTER //
// ./src/components/pages/Sitemap.js